import { render, staticRenderFns } from "./SliderDot.vue?vue&type=template&id=13d3f1fe&scoped=true&"
import script from "./SliderDot.vue?vue&type=script&lang=js&"
export * from "./SliderDot.vue?vue&type=script&lang=js&"
import style0 from "./SliderDot.vue?vue&type=style&index=0&id=13d3f1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3f1fe",
  null
  
)

export default component.exports